// @flow

import styled from 'styled-components';

export const SectionTitle = styled.h2`
  font-size: 1.3em;
  font-family: ${props => props.theme.fontFamily.display};
  text-align: center;
  line-height: 1.6;
`;

export const SectionSubtitle = styled.p`
  text-align: center;
  font-size: 1.1em;
  line-height: 1.6;
`;
